import pdfIcon from "./../../../assets/images/pdf.png"; // Adjust the path as necessary

function BoardCeo() {

  const documents = [
    {
      title: "CAS-701-01-02 ",
      modified: "July 19, 2019",
      items: [
        "Casualty-Accident Report (TV5-325)",
      ],
    },
    {
      title: "CAS-701-01-03 ",
      modified: "July 19, 2019",
      items: [
        "Casualty-Accident Report incl. Occupational Report",
        //   "INS-701-09-01 Towage Inspection",
      ],
    },
    {
      title: "CAS-701-01-04 ",
      modified: "July 19, 2019",
      items: [
        "Occupational Casualty Reporting Form (Shore Labour)",
        //   "INNotification_of_intention_to_build_0.",
      ],
    },
    {
      title: "CAS-701-01-05 ",
      modified: "July 19, 2019",
      items: [
        "Small Vessel Marine Incident Report Form",
        //   "INNotification_of_intention_to_build_0.",
      ],
    },
  ];

  return (
    <>
      <div className="service-title text-green-38B652 font-700 mb-3 text-uppercase">
        SAMSA BOARD AND CEO
      </div>
      <div className="service-box mb-5 mb-sm-4">
        All queries or messages that need the direct attention of the SAMSA BOARD or CEO, may be sent using the details below:

      </div>
      <div className="font-17 mb-4">

      </div>
      <div className="font-17 mb-4">
        <p className="font-17 text-primary-color"><b>Company Secretary:</b></p>
        <div className="container my-3">
          <div
            className="card shadow-sm border-0 p-3"
            style={{ maxWidth: "500px", borderRadius: "12px" }}>
            <div className="row mb-2">
              <div className="col-5 col-md-2 fw-semibold">Email:</div>
              <div className="col-7 col-md-8">
                <a href="mailto:compsec@samsa.org.za" className="text-decoration-none">
                  compsec@samsa.org.za
                </a>
              </div>
            </div>
          </div>
        </div>

        <p className="font-17 text-primary-color">(Please note that all correspondence to the SAMSA BOARD go through the Company Secretaries office). </p>
        <br />
        <p className="font-17 text-primary-color"><b>SAMSA CEO: </b></p>
        <div className="container my-3">
          <div
            className="card shadow-sm border-0 p-3"
            style={{ maxWidth: "500px", borderRadius: "12px" }}>
            <div className="row mb-2">
              <div className="col-5 col-md-2 fw-semibold">Email:</div>
              <div className="col-7 col-md-8">
                <a href="mailto:ceo@samsa.org.za" className="text-decoration-none">
                  ceo@samsa.org.za
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>





      <div className="row g-3 g-sm-4">
        {/* <div className="col-lg-5 col-md-6 col-sm-6">
                    <p className="font-17 text-primary-color">
                        <b>​​Inland Region (Boating)</b>
                    </p>
                    <p className="font-17 text-primary-color">
                        MRCC (Gauteng, Free State, Mpumalanga, Limpopo and North West)
                    </p>
                    <p className="font-17 text-primary-color">
                        <span className="font-600">Contact Number:</span> 021-938-3300
                    </p>
                </div> */}

        {/* <div className="col-lg-5 col-md-6 col-sm-6">
                    <p className="font-17 text-primary-color">
                        <b>Western Region</b>
                    </p>
                    <p className="font-17 text-primary-color">
                        (Port Nolloth, Saldanha Bay and Cape Town){" "}
                    </p>
                    <p className="font-17 text-primary-color">
                        <span className="font-600">Contact Number:</span> 072-364-4958
                    </p>
                </div> */}

        {/* <div className="col-lg-5 col-md-6 col-sm-6">
                    <p className="font-17 text-primary-color">
                        <b>​Southern Region</b>
                    </p>
                    <p className="font-17 text-primary-color">
                        (Mossel Bay; Port Elizabeth and East London)
                    </p>
                    <p className="font-17 text-primary-color">
                        <span className="font-600">Contact Number:</span> 076-859-6790
                    </p>
                </div> */}

        {/* <div className="col-lg-5 col-md-6 col-sm-6">
                    <p className="font-17 text-primary-color">
                        <b>Eastern Region</b>
                    </p>
                    <p className="font-17 text-primary-color">(Durban & Richards Bay) </p>
                    <p className="font-17 text-primary-color">
                        <span className="font-600">Contact Number:</span> 066 282 4304
                    </p>
                </div> */}

        {/* <div className="col-12 ">
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="true"
                  aria-controls="blackTabOne"
                >
                  Casualty Report Forms
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse show"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <ul className="strip-ul">
                    {documents.map((doc, index) => (
                      <li key={index}>
                        <div className="row g-4">
                          <div className="col-auto">
                            <img src={pdfIcon} alt="PDF icon" />
                          </div>
                          <div className="col">
                            <div className="row g-4">
                              <div className="col-md">
                                <div className="font-18 font-600">
                                  File Name
                                </div>
                                <div className="font-16 font-400">
                                  <p className="text-orange-ef3e33 text-uppercase">
                                    {doc.title}
                                  </p>
                                  
                                    {doc.items.map((item, i) => (
                                      <p key={i}><a href="#">{item}</a></p>
                                    ))}
                                  
                                </div>
                              </div>
                              <div className="col-md-auto">
                                <div className="font-18 font-600">Modified</div>
                                <div className="font-16 font-400">
                                  {doc.modified}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}

export default BoardCeo;